import { StatusEnum } from '@/types/cart';
import { ProductCardProps } from '../types';
import { UseGetTargetProductCouponInfoReturnType } from '../hook/useGetTargetProductCouponInfo';
import { formatPercentageCouponValue } from './product-target-coupon';

const getTargetCouponTrackingInfo = (
  props: Partial<ProductCardProps>,
  targetCouponInfo: UseGetTargetProductCouponInfoReturnType
) => {
  const { data } = props;
  const { copywriting, sold_status, extra_attrs = '' } = data || {};
  const { show, subtraction } = targetCouponInfo;

  const { coupon_type = '', coupon_value = '' } = extra_attrs ? JSON.parse(extra_attrs || '{}') : {};

  if (sold_status && [StatusEnum.sold_out, StatusEnum.change_other_day].includes(sold_status as StatusEnum)) {
    return null;
  }

  if (copywriting && copywriting.claim_desc) {
    return {
      coupon_type: coupon_type,
      coupon_value: coupon_value
    };
  }

  if (!show) {
    return null;
  }

  return {
    coupon_type: subtraction?.type,
    coupon_value:
      subtraction?.type === 'D'
        ? subtraction?.reduce
        : formatPercentageCouponValue(subtraction?.percentage, Number(data?.price))
  };
};

export default getTargetCouponTrackingInfo;
